import { useQueries } from "@tanstack/react-query";
import { assignedAgentsQueryOptions } from "web_myplann/Api/Advisor/assignedAgentsQueryOptions";
import { mapAdvisorsQueries } from "web_myplann/Api/Advisor/mapAdvisorsQueries";
import { UserAgentStatusEnum } from "web_myplann/Infrastructure/Api/Api";

export const useAdvisorsQuery = () =>
	useQueries({
		queries: [
			assignedAgentsQueryOptions(UserAgentStatusEnum.Connected),
			assignedAgentsQueryOptions(UserAgentStatusEnum.PendingClient),
		] as const,
		combine: mapAdvisorsQueries,
	});
